import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

export const DistributorsAPI = (baseURL: string | undefined, clientId: string) => {
    const api = AxiosAPI({
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    });

    const saveDistributors = (data: any) => {
        const serviceUrl = `/bookbuilding-api/Distributors/SaveDistributors`;
        return api.post(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const updateDistributors = (data: any) => {
        const serviceUrl = `/bookbuilding-api/Distributors/UpdateDistributors`;
        return api.put(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

	const getDistributors = (contractId: number) => {
        const serviceUrl = `/bookbuilding-api/Distributors/GetDistributors`;
        return api.get(serviceUrl, { params: { contractId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const getDefaultValuesDistributor = (contractId: number) => {
        const serviceUrl = `/bookbuilding-api/Distributors/GetDefaultValuesDistributor`;
        return api.get(serviceUrl, { params: { contractId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    return {
        saveDistributors,
        updateDistributors,
        getDistributors,
        getDefaultValuesDistributor,
    };
};